<template>
  <div class="base-info-detail">
    <slot></slot>
  </div>
</template>

<script>

/**
 * The stuff inside the dark blue block.
 */
export default {
name: "BaseInfoDetail"
}
</script>

<style lang="scss" scoped>
.base-info-detail {
  @extend %info-detail;
}
</style>
